

export const SET_WALLET_AMOUNT = 'SET_WALLET_AMOUNT';

export const setWalletAmount = amount => ({
  type: SET_WALLET_AMOUNT,
  payload: amount
});
